import raw from './lotsogBriefingWordRate.json';

/** Words per minute used to map LOTSOG “minutes available” ↔ target briefing word budget (listen time). */
export const LOTSOG_BRIEFING_WORDS_PER_MINUTE = Number(raw.BRIEFING_WORDS_PER_MINUTE) || 200;

/** Max “minutes” of copy allocated to the world-news slice (absolute cap vs total budget fraction). */
export const LOTSOG_WORLD_NEWS_CAP_MINUTES = Number(raw.WORLD_NEWS_CAP_MINUTES) || 3;

export const LOTSOG_WORLD_NEWS_CAP_WORDS = Math.round(
  LOTSOG_WORLD_NEWS_CAP_MINUTES * LOTSOG_BRIEFING_WORDS_PER_MINUTE
);

/**
 * @param {number|string|null|undefined} minutes
 * @returns {number}
 */
export function lotsogWordBudgetFromMinutes(minutes) {
  const m = Number(minutes);
  if (!Number.isFinite(m) || m <= 0) return 0;
  return Math.round(m * LOTSOG_BRIEFING_WORDS_PER_MINUTE);
}

/**
 * @param {number|string|null|undefined} wordCount
 * @returns {number}
 */
export function lotsogListeningMinutesFromWords(wordCount) {
  const w = Number(wordCount);
  if (!Number.isFinite(w) || w <= 0) return 0;
  return Number((w / LOTSOG_BRIEFING_WORDS_PER_MINUTE).toFixed(2));
}
